import { EquipmentItem } from "@/backend/models/equipmentItem";

export function ConfigurationCell(props: { item: EquipmentItem }) {
  const { item } = props;

  return (
    <div className="d-flex gap-1 flex-wrap">
      {item.defaultConfiguration.objectInstance.properties.map((property) => {
        if (property.value) {
          return (
            <div key={property.valueId} className='badge bg-success'>
              {property.key}: {property.value}
            </div>
          );
        }
        return (
          <div key={property.valueId} className='badge bg-danger'>
            {property.key}
          </div>
        );
      })}
    </div>
  );
}